import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseOrderUpdateAtom = createMutationAtomFactory(
  'customerPortal.purchaseOrderUpdate',
  (params: {
    id: string;
    purchaseOrderNumber?: string;
    contactId?: string;
    internalNotes?: string;
    externalNotes?: string;
  }) => ({
    tradeSalesOrderUpdate: {
      __args: {
        id: params.id,
        input: {
          counterpartyReferenceNumber: params.purchaseOrderNumber,
          contactId: params.contactId,
          customerInternalNotes: params.internalNotes,
          customerExternalNotes: params.externalNotes,
        },
      },
      id: true,
    },
  }),
);
